// extracted by css-extract-rspack-plugin
export default {"manualCopyUrl":"NativeShareAction-module__manualCopyUrl__cDBRn"};